import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import PageHeaderContainer from 'shared/components/PageHeader/container'
import useWorkspace from 'hooks/useWorkspace'

export const IntegrationContainer = ({ children }) => {
  const workspaceToken = useWorkspace()
  return (
    <React.Fragment>
      <PageHeaderContainer title="Integrations" />
      <div className="container page-v-padding ph2 ph3-tablet ph4-computer">
        <Link to={`/${workspaceToken}/settings/integrations/`}>
          <i className="fas fa-arrow-left icon" />
          Back to Integrations
        </Link>

        <div className="ui segment admin-section bg-white">{children}</div>
      </div>
    </React.Fragment>
  )
}

IntegrationContainer.propTypes = {
  children: PropTypes.node,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntegrationContainer.js